t = require('views/internal/teacup-with-helpers')('header_public_board')

module.exports = ->
  t.p '.u-bottom', ->
    t.mustacheBlock 'interactionText', ->
      t.span '.u-inline-block', ->
        t.text t.mustacheVar('interactionText')
    t.span '.u-inline-block', ->
      t.a { class: "button primary", href: t.mustacheVar('signupUrl') }, ->
        t.format t.mustacheVar('ctaKey')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_public_board.coffee